import React, { useState } from "react";
import { FaRegFileAlt } from "react-icons/fa";
import { MdOutlineFolder } from "react-icons/md";
import styles from "../../Documents.module.css";
import Options from "../Options/Options";
import { IoMdCheckmark } from "react-icons/io";
import { Button, Input, InputGroup } from "rsuite";
import { FcFolder } from "react-icons/fc";
import { FaFilePdf, FaFileWord, FaFile } from "react-icons/fa6";
import { CiFileOn } from "react-icons/ci";
import {
  BsFileEarmark,
  BsFiletypePdf,
  BsFiletypeDoc,
  BsFiletypeDocx,
} from "react-icons/bs";
import api from "api";

function Item({ item, handleRename, onOpenFolder }) {
  const [name, setName] = useState(item.name);
  const [editing, setEditing] = useState(false);
  const [initialName, setInitialName] = useState(item.name);

  const onRenameClick = () => {
    handleRename(item, name);
    setEditing(false);
  };

  const onBlur = () => {
    setName(initialName);
    setEditing(false);
  };

  const handleDownload = async () => {
    const response = await api.documents.fileDownload(item.id);
    if (!response) return;

    const downloadUrl =
      typeof response === "string"
        ? response
        : response.url || response.signedUrl || response.presignedUrl;

    if (!downloadUrl) return;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  function getFileIcon(item) {
    if (!item.fileId) {
      return <FcFolder style={{ height: "80px", width: "80px" }} />;
    }

    const extension = item.name.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return (
          <BsFiletypePdf
            style={{ color: "#f67d74", height: "56px", width: "56px" }}
          />
        );
      case "doc":
        return (
          <BsFiletypeDoc
            style={{ color: "#2196f3", height: "56px", width: "56px" }}
          />
        );
      case "docx":
        return (
          <BsFiletypeDocx
            style={{ color: "#2196f3", height: "56px", width: "56px" }}
          />
        );
      default:
        return (
          <BsFileEarmark
            style={{ color: "#9d9d9d", height: "56px", width: "56px" }}
          />
        );
    }
  }

  return (
    <div className={styles.gridItem}>
      {item.fileId ? (
        <div className={styles.iconContainer} onDoubleClick={handleDownload}>
          {getFileIcon(item)}
        </div>
      ) : (
        <div
          className={styles.iconContainer}
          onDoubleClick={() => onOpenFolder(item)}
        >
          {getFileIcon(item)}
        </div>
      )}

      <div className={styles.optionsButton}>
        <Options setEditing={setEditing} item={item} />
      </div>
      <div className={styles.item_name}>
        {editing ? (
          <InputGroup className={styles.gridItemInputs} onBlur={onBlur}>
            <Input
              value={name}
              onChange={(value) => setName(value)}
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  setName(initialName);
                  setEditing(false);
                } else if (e.key === "Enter") {
                  onRenameClick();
                }
              }}
              autoFocus
              onFocus={(e) => e.target.select()}
            />
            <InputGroup.Button onMouseDown={onRenameClick}>
              <IoMdCheckmark size={"15px"} />
            </InputGroup.Button>
          </InputGroup>
        ) : (
          <div className={styles.gridItemOptions}>
            <span
              className={styles.gridItemText}
              onClick={() => {
                setInitialName(name);
                setEditing(true);
              }}
            >
              {name.length < 32 ? name : name.slice(0, 34) + "..."}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default Item;
